import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCheckAltRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path fill="#1E1E1E" d="M0 0h32v32H0z" />
    <path
      fill="#C3C3C3"
      d="M-456-430a2 2 0 0 1 2-2h2562c1.1 0 2 .895 2 2V708c0 1.105-.9 2-2 2H-454a2 2 0 0 1-2-2z"
    />
    <path
      fill="currentColor"
      fillOpacity={0.1}
      d="M-454-431h2562v-2H-454zm2563 1V708h2V-430zm-1 1139H-454v2h2562zm-2563-1V-430h-2V708zm1 1a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3zm2563-1c0 .552-.45 1-1 1v2c1.66 0 3-1.343 3-3zm-1-1139c.55 0 1 .448 1 1h2c0-1.657-1.34-3-3-3zm-2562-2a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1z"
    />
    <path fill="currentColor" d="M-346-341h1920v960H-346z" />
    <path
      fill="url(#a)"
      d="M-6 16C-6 3.85 3.85-6 16-6h418v44H16C3.85 38-6 28.15-6 16"
    />
    <g fill="#4855DC">
      <rect width={32} height={32} fillOpacity={0.1} rx={16} />
      <path
        fillRule="evenodd"
        d="m21.944 10.621-8.354 8.062-2.216-2.369c-.409-.385-1.05-.408-1.517-.081-.455.338-.583.933-.303 1.411l2.625 4.27c.256.397.7.642 1.201.642.479 0 .934-.245 1.19-.642.42-.548 8.435-10.103 8.435-10.103 1.05-1.073-.221-2.018-1.061-1.202z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1={-6}
        x2={434}
        y1={16}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopColor="#F9FAFB" />
        <stop offset={1} stopColor="currentColor" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgCheckAltRounded
